import CachedIcon from '@mui/icons-material/Cached'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Alert, Box, Button, Stack } from '@mui/material'
import Link from 'next/link'
import { useCallback, useState } from 'react'
import { pagesPath } from '~/lib/$path'

export const AddNewTicket = ({ onReload }: { onReload: () => void }) => {
  const [linkClicked, setLinkClicked] = useState(false)
  const handleLinkClick = useCallback(() => setLinkClicked(true), [setLinkClicked])
  const handleReload = useCallback(() => {
    setLinkClicked(false)
    onReload()
  }, [onReload])

  return (
    <>
      <Stack position="relative">
        <Alert severity="error" variant="outlined">
          <Box>利用できるチケットがないため審査に提出できません。</Box>
          <Link href={pagesPath.contract.$url().pathname} target="_blank" onClick={handleLinkClick}>
            チケットの購入・契約ページ
            <OpenInNewIcon
              sx={{
                fontSize: 'inherit',
              }}
            />
          </Link>
          でチケットを購入してください
        </Alert>
        {linkClicked && (
          <Box
            sx={{
              position: 'absolute',
              top: -10,
              left: -10,
              right: -10,
              bottom: -10,
              borderRadius: 4,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button variant="contained" color="primary" onClick={handleReload} startIcon={<CachedIcon />}>
              利用可能なチケットを再読み込み
            </Button>
          </Box>
        )}
      </Stack>
    </>
  )
}
